export default {
	name: "submission-management",
	props:{
		campaignId:{
			default: null
		}
	},
	data() {
		return {
			sites:[],
			campaigns: [],
			submissions: [],
			submissionsHeadings: [
				{
					text: "Site",
					field: "site"
				},
				{
					text: "Campaign",
					field: "campaignName"
				},
				{
					text: "Submission Date",
					field: "insertedOnString"
				},
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Mobile Number",
					field: "mobileNumber"
				},
				{
					text: "Email Address",
					field: "emailAddress"
				},
				{
					text: "Card Number",
					field: "cardNumber"
				},
				{
					text: "Is Loyalty Member?",
					field: "isLoyalCustomer"
				},
				{
					text: "Is Winner?",
					field: "isWinner"
				}
			],
			actionKeys:{
				viewSubmissions: "viewSubmissions"
			},
			viewSubmissionModal: {
				showModal: false,
				modalId: "viewSubmissionModal",
				heading: "View Submission",
				submission: {},
				submissionIsDrawnWinner: false
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				siteId: 0,
				campaignId: null
			},
			hasLoadedAllSites: false,
			hasLoadedAllCampaigns: false,
			hasLoadedSubmissions: false,
			loading: false
		};
	},
	methods: {
		getAllSubmissions(){
			this.loading = true;
			let request = {
				searchTerm: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: 250000,
				siteId: this.filter.siteId === 0 ? null : this.filter.siteId,
				campaignId: this.filter.campaignId === 0 ? null : this.filter.campaignId
			};
			competitionService.getAllSubmissions(request).then(
				response => {
					if(response.status === 200){
						this.submissions = response.data.result;
						this.submissions = dataTableHelper.castFieldValues(this.submissions);
						for(var i = 0; i < this.submissions.length; i++){
							this.submissions[i].actions = [
								{
									name: "View Submissions",
									key: this.actionKeys.viewSubmissions,
									elementId: "btnViewSubmissionsAction"
								}
							];
						}
					}
					this.filterStateChanged = false;
					this.hasLoadedSubmissions = true;
					this.loading = false;
				}
			);
		},
		getCampaigns(){
			//this.loading = true;
			let request = {
				searchTerm: null,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: 250000,
				// fromDateCreated: this.filter.fromDateCreated,
				// toDateCreated: this.filter.toDateCreated,
				isActive: true,
				siteId: this.filter.siteId === 0 ? null : this.filter.siteId
			};
			competitionService.getAllCampaigns(request).then(
				response => {
					if(response.status === 200){
						this.campaigns = response.data.result;
						this.campaigns.unshift(
							{
								campaignId: 0,
								campaignName: "All"
							});
						this.campaigns = $.map(this.campaigns,
							function (obj) {
								obj.id = obj.id || obj.campaignId;
								obj.text = obj.text || obj.campaignName;
								return obj;
							});
						//this.loading = false;
						this.hasLoadedAllCampaigns = true;
						
						var self = this;
						setTimeout(function(){
							if(self.campaignId !== null && self.campaignId !== undefined && self.campaignId !== ""){
								self.filter.campaignId = self.campaignId;
							}
							else{
								self.filter.campaignId = 0;
							}

							if(self.hasLoadedAllCampaigns && self.hasLoadedAllSites && !self.hasLoadedSubmissions){
								self.getAllSubmissions();
							}
							console.log("campaignId", self.filter.campaignId);
						}, 100);
					}
				}
			);
		},
		getSites(){
			systemService.getSites().then(
				response => {
					this.sites = response.data.result;
					this.sites.unshift(
						{
							siteId: 0,
							siteName: "All"
						});
					this.sites = $.map(this.sites,
						function (obj) {
							obj.id = obj.id || obj.siteId;
							obj.text = obj.text || obj.siteName;
							return obj;
						});
					console.log("sites", this.sites);
					this.hasLoadedAllSites = true;
					if(this.hasLoadedAllCampaigns && this.hasLoadedAllSites && !this.hasLoadedSubmissions){
						this.getAllSubmissions();
					}
					var self = this;
					setTimeout(function(){
						self.filter.siteId = 0;
						self.getCampaigns();
					}, 100);
				}
			);
		},
		onCampaignFilterSelect(campaign){
			console.log("campaign", campaign);
			if(this.filter.campaignId !== campaign.id) {
				this.filterStateChanged = true;
				this.filter.campaignId = campaign.id;
			}
			// if(campaign.id === 0){
			// 	this.filter.campaignId = null;
			// }
			// else{
			// 	this.filter.campaignId = campaign.id;
			// }
		},
		onSiteFilterSelect(site){
			console.log("site", site);
			if(this.filter.siteId !== site.id) {
				this.filterStateChanged = true;
				this.filter.siteId = site.id;
				this.getCampaigns();
			}
			// if(site.id === 0){
			// 	this.filter.siteId = null;
			// }
			// else{
			// 	this.filter.siteId = site.id;
			// }
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getAllSubmissions();
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getAllSubmissions();
		},
		onSubmissionActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.viewSubmissions:
					this.viewSubmissionModal.showModal = true;
					this.viewSubmissionModal.submission = actionAndData.data;
					break;
			}
		},
		onViewSubmissionModalClose(){
			this.viewSubmissionModal.showModal = false;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Submissions");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Campaigns - Submissions");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getSites();
	},
	watch: {
		campaignId:{
			handler: function (){
				if(this.campaignId !== null && this.campaignId !== undefined){
					this.filter.campaignId = this.campaignId;
				}
			}
		}
	}
};